import { types } from "@prominentmedia/coreredux";

const UPDATE_PROJECT_PHASES_OPEN = "UPDATE_PROJECT_PHASES_OPEN";
const UPDATE_PROJECT_PHASES_OPEN_TOGGLE = "UPDATE_PROJECT_PHASES_OPEN_TOGGLE";

const UPDATE_PROJECT_INVOICES_OPEN = "UPDATE_PROJECT_INVOICES_OPEN";
const UPDATE_PROJECT_INVOICES_OPEN_TOGGLE = "UPDATE_PROJECT_INVOICES_OPEN_TOGGLE";

const TOGGLE_SHOW_COMPLETE_PROJECTS = "TOGGLE_SHOW_COMPLETE_PROJECTS";

const LOAD_ENGINEER_REPORTS_SUCCESS = "LOAD_ENGINEER_REPORTS_SUCCESS";

const LOAD_MILESTONETEMPLATES_SUCCESS = "LOAD_MILESTONETEMPLATES_SUCCESS";
const LOAD_MILESTONETEMPLATE_SUCCESS = "LOAD_MILESTONETEMPLATE_SUCCESS";
const LOAD_MILESTONETEMPLATES_UPDATE_SUCCESS = "LOAD_MILESTONETEMPLATES_UPDATE_SUCCESS";
const DELETED_MILESTONETEMPLATE = "DELETED_MILESTONETEMPLATE";
const DELETED_MILESTONETEMPLATE_INCOMING = "DELETED_MILESTONETEMPLATE_INCOMING";
const MILESTONETEMPLATE_UPDATE_REQUIRED = "MILESTONETEMPLATE_UPDATE_REQUIRED";
const UPDATED_MILESTONETEMPLATE_INCOMING = "UPDATED_MILESTONETEMPLATE_INCOMING";
const UPDATED_MILESTONETEMPLATE_SUCCESS = "UPDATED_MILESTONETEMPLATE_SUCCESS";

const LOAD_MILESTONETEMPLATEENTRY_SUCCESS = "LOAD_MILESTONETEMPLATEENTRY_SUCCESS";
const DELETED_MILESTONETEMPLATEENTRY = "DELETED_MILESTONETEMPLATEENTRY";
const DELETED_MILESTONETEMPLATEENTRY_INCOMING = "DELETED_MILESTONETEMPLATEENTRY_INCOMING";
const MILESTONETEMPLATEENTRY_UPDATE_REQUIRED = "MILESTONETEMPLATEENTRY_UPDATE_REQUIRED";
const UPDATED_MILESTONETEMPLATEENTRY_INCOMING = "UPDATED_MILESTONETEMPLATEENTRY_INCOMING";
const UPDATED_MILESTONETEMPLATEENTRY_SUCCESS = "UPDATED_MILESTONETEMPLATEENTRY_SUCCESS";

const DELETED_PHASENOTE = "DELETED_PHASENOTE";
const DELETED_PHASENOTE_INCOMING = "DELETED_PHASENOTE_INCOMING";
const UPDATED_PHASENOTE_INCOMING = "UPDATED_PHASENOTE_INCOMING";
const UPDATED_PHASENOTE_SUCCESS = "UPDATED_PHASENOTE_SUCCESS";	

const LOAD_PROJECTITEMSTATUSS_SUCCESS = "LOAD_PROJECTITEMSTATUSS_SUCCESS";
const LOAD_PROJECTITEMTYPES_SUCCESS = "LOAD_PROJECTITEMTYPES_SUCCESS";
const LOAD_PROJECTTYPES_SUCCESS = "LOAD_PROJECTTYPES_SUCCESS";

const LOAD_CONTACTS_SUCCESS = "LOAD_CONTACTS_SUCCESS";
const LOAD_CONTACT_SUCCESS = "LOAD_CONTACT_SUCCESS";
const LOAD_CONTACTS_UPDATE_SUCCESS = "LOAD_CONTACTS_UPDATE_SUCCESS";
const DELETED_CONTACT = "DELETED_CONTACT";
const DELETED_CONTACT_INCOMING = "DELETED_CONTACT_INCOMING";
const UPDATED_CONTACT_INCOMING = "UPDATED_CONTACT_INCOMING";
const UPDATED_CONTACT_SUCCESS = "UPDATED_CONTACT_SUCCESS";

const DELETED_INVOICE = "DELETED_INVOICE";
const DELETED_INVOICE_INCOMING = "DELETED_INVOICE_INCOMING";
const CREATED_INVOICE_SUCCESS = "CREATED_INVOICE_SUCCESS";
const CREATED_INVOICE_INCOMING = "CREATED_INVOICE_INCOMING";

const LOAD_ORGANISATIONS_SUCCESS = "LOAD_ORGANISATIONS_SUCCESS";
const LOAD_ORGANISATION_SUCCESS = "LOAD_ORGANISATION_SUCCESS";
const LOAD_ORGANISATIONS_UPDATE_SUCCESS = "LOAD_ORGANISATIONS_UPDATE_SUCCESS";
const DELETED_ORGANISATION = "DELETED_ORGANISATION";
const DELETED_ORGANISATION_INCOMING = "DELETED_ORGANISATION_INCOMING";
const UPDATED_ORGANISATION_INCOMING = "UPDATED_ORGANISATION_INCOMING";
const UPDATED_ORGANISATION_SUCCESS = "UPDATED_ORGANISATION_SUCCESS";

const LOAD_PHASES_SUCCESS = "LOAD_PHASES_SUCCESS";
const LOAD_PHASE_SUCCESS = "LOAD_PHASE_SUCCESS";
const LOAD_PHASES_UPDATE_SUCCESS = "LOAD_PHASES_UPDATE_SUCCESS";
const DELETED_PHASE = "DELETED_PHASE";
const DELETED_PHASE_INCOMING = "DELETED_PHASE_INCOMING";
const UPDATED_PHASE_INCOMING = "UPDATED_PHASE_INCOMING";
const UPDATED_PHASE_SUCCESS = "UPDATED_PHASE_SUCCESS";

const LOAD_PROJECTS_SUCCESS = "LOAD_PROJECTS_SUCCESS";
const LOAD_PROJECT_SUCCESS = "LOAD_PROJECT_SUCCESS";
const LOAD_PROJECTS_UPDATE_SUCCESS = "LOAD_PROJECTS_UPDATE_SUCCESS";
const LOAD_COMPLETEPROJECTS_SUCCESS = "LOAD_COMPLETEPROJECTS_SUCCESS";
const DELETED_PROJECT = "DELETED_PROJECT";
const DELETED_PROJECT_INCOMING = "DELETED_PROJECT_INCOMING";
const UPDATED_PROJECT_INCOMING = "UPDATED_PROJECT_INCOMING";
const UPDATED_PROJECT_SUCCESS = "UPDATED_PROJECT_SUCCESS";
const LOAD_PROJECT_WITH_PHASES_SUCCESS = "LOAD_PROJECT_WITH_PHASES_SUCCESS";

const LOAD_PROJECTITEM_SUCCESS = "LOAD_PROJECTITEM_SUCCESS";
const DELETED_PROJECTITEM = "DELETED_PROJECTITEM";
const DELETED_PROJECTITEM_INCOMING = "DELETED_PROJECTITEM_INCOMING";
const UPDATED_PROJECTITEM_INCOMING = "UPDATED_PROJECTITEM_INCOMING";
const UPDATED_PROJECTITEM_SUCCESS = "UPDATED_PROJECTITEM_SUCCESS";

const LOAD_PROJECTITEMACTIVITY_SUCCESS = "LOAD_PROJECTITEMACTIVITY_SUCCESS";
const DELETED_PROJECTITEMACTIVITY = "DELETED_PROJECTITEMACTIVITY";
const DELETED_PROJECTITEMACTIVITY_INCOMING = "DELETED_PROJECTITEMACTIVITY_INCOMING";
const UPDATED_PROJECTITEMACTIVITY_INCOMING = "UPDATED_PROJECTITEMACTIVITY_INCOMING";
const UPDATED_PROJECTITEMACTIVITY_SUCCESS = "UPDATED_PROJECTITEMACTIVITY_SUCCESS";

const LOAD_PROJECTITEMMILESTONE_SUCCESS = "LOAD_PROJECTITEMMILESTONE_SUCCESS";
const DELETED_PROJECTITEMMILESTONE = "DELETED_PROJECTITEMMILESTONE";
const DELETED_PROJECTITEMMILESTONE_INCOMING = "DELETED_PROJECTITEMMILESTONE_INCOMING";
const UPDATED_PROJECTITEMMILESTONE_INCOMING = "UPDATED_PROJECTITEMMILESTONE_INCOMING";
const UPDATED_PROJECTITEMMILESTONE_SUCCESS = "UPDATED_PROJECTITEMMILESTONE_SUCCESS";

const DELETED_PROJECTITEMNOTE = "DELETED_PROJECTITEMNOTE";
const DELETED_PROJECTITEMNOTE_INCOMING = "DELETED_PROJECTITEMNOTE_INCOMING";
const UPDATED_PROJECTITEMNOTE_INCOMING = "UPDATED_PROJECTITEMNOTE_INCOMING";
const UPDATED_PROJECTITEMNOTE_SUCCESS = "UPDATED_PROJECTITEMNOTE_SUCCESS";

const LOAD_SITES_SUCCESS = "LOAD_SITES_SUCCESS";
const LOAD_SITE_SUCCESS = "LOAD_SITE_SUCCESS";
const LOAD_SITES_UPDATE_SUCCESS = "LOAD_SITES_UPDATE_SUCCESS";
const DELETED_SITE = "DELETED_SITE";
const DELETED_SITE_INCOMING = "DELETED_SITE_INCOMING";
const UPDATED_SITE_INCOMING = "UPDATED_SITE_INCOMING";
const UPDATED_SITE_SUCCESS = "UPDATED_SITE_SUCCESS";
	

const UPDATE_NAV_AFTER_LOGIN_DETAILS_SUCCESS =
	"UPDATE_NAV_AFTER_LOGIN_DETAILS";
const UPDATE_SIDEBARSHOW = "UPDATE_SIDEBARSHOW";
const LOAD_USERS_SUCCESS = "LOAD_USERS_SUCCESS";
const LOAD_USERS_UPDATE_SUCCESS = "LOAD_USERS_UPDATE_SUCCESS";
const LOAD_USER_SUCCESS = "LOAD_USER_SUCCESS";
const DELETED_USER = "DELETE_FROM_USER_LIST";
const DELETED_USER_INCOMING = "DELETED_USER_INCOMING";
const UPDATED_USER_INCOMING = "UPDATED_USER_INCOMING";
const UPDATED_USER_SUCCESS = "UPDATED_USER_SUCCESS";

const appTypes = {
	...types
	,UPDATE_PROJECT_PHASES_OPEN
	, UPDATE_PROJECT_PHASES_OPEN_TOGGLE
	, UPDATE_PROJECT_INVOICES_OPEN
	, UPDATE_PROJECT_INVOICES_OPEN_TOGGLE
	, TOGGLE_SHOW_COMPLETE_PROJECTS
	, LOAD_ENGINEER_REPORTS_SUCCESS
		,UPDATE_NAV_AFTER_LOGIN_DETAILS_SUCCESS
	,UPDATE_SIDEBARSHOW
	,LOAD_USERS_SUCCESS
	,LOAD_USERS_UPDATE_SUCCESS
	,LOAD_USER_SUCCESS
	,DELETED_USER
	,DELETED_USER_INCOMING
	, UPDATED_USER_INCOMING
	, UPDATED_USER_SUCCESS
			,LOAD_CONTACTS_SUCCESS
		,LOAD_CONTACT_SUCCESS
		,LOAD_CONTACTS_UPDATE_SUCCESS
		,DELETED_CONTACT
		,DELETED_CONTACT_INCOMING
		, UPDATED_CONTACT_INCOMING
		, UPDATED_CONTACT_SUCCESS	
	, CREATED_INVOICE_SUCCESS
		,DELETED_INVOICE
		,DELETED_INVOICE_INCOMING
	, CREATED_INVOICE_INCOMING
			,LOAD_ORGANISATIONS_SUCCESS
		,LOAD_ORGANISATION_SUCCESS
		,LOAD_ORGANISATIONS_UPDATE_SUCCESS
		,DELETED_ORGANISATION
		,DELETED_ORGANISATION_INCOMING
	, UPDATED_ORGANISATION_INCOMING
	, UPDATED_ORGANISATION_SUCCESS
			,LOAD_PHASES_SUCCESS
		,LOAD_PHASE_SUCCESS
		,LOAD_PHASES_UPDATE_SUCCESS
		,DELETED_PHASE
		,DELETED_PHASE_INCOMING
	, UPDATED_PHASE_INCOMING
	, UPDATED_PHASE_SUCCESS
			,LOAD_PROJECTS_SUCCESS
		,LOAD_PROJECT_SUCCESS
	, LOAD_PROJECTS_UPDATE_SUCCESS
	, LOAD_COMPLETEPROJECTS_SUCCESS
		,DELETED_PROJECT
		,DELETED_PROJECT_INCOMING
	, UPDATED_PROJECT_INCOMING
	, UPDATED_PROJECT_SUCCESS
	, LOAD_PROJECT_WITH_PHASES_SUCCESS
		,LOAD_PROJECTITEM_SUCCESS
		,DELETED_PROJECTITEM
		,DELETED_PROJECTITEM_INCOMING
	, UPDATED_PROJECTITEM_INCOMING
	, UPDATED_PROJECTITEM_SUCCESS	
		,LOAD_PROJECTITEMACTIVITY_SUCCESS	
		,DELETED_PROJECTITEMACTIVITY
		,DELETED_PROJECTITEMACTIVITY_INCOMING
	, UPDATED_PROJECTITEMACTIVITY_INCOMING
	, UPDATED_PROJECTITEMACTIVITY_SUCCESS					
		,LOAD_PROJECTITEMMILESTONE_SUCCESS
		,DELETED_PROJECTITEMMILESTONE
		,DELETED_PROJECTITEMMILESTONE_INCOMING
	, UPDATED_PROJECTITEMMILESTONE_INCOMING
	, UPDATED_PROJECTITEMMILESTONE_SUCCESS		
		,DELETED_PROJECTITEMNOTE
		,DELETED_PROJECTITEMNOTE_INCOMING
	, UPDATED_PROJECTITEMNOTE_INCOMING
	, UPDATED_PROJECTITEMNOTE_SUCCESS
			,LOAD_PROJECTITEMSTATUSS_SUCCESS	
			,LOAD_PROJECTITEMTYPES_SUCCESS	
			,LOAD_PROJECTTYPES_SUCCESS		
			,LOAD_SITES_SUCCESS
		,LOAD_SITE_SUCCESS
		,LOAD_SITES_UPDATE_SUCCESS
		,DELETED_SITE
		,DELETED_SITE_INCOMING
	, UPDATED_SITE_INCOMING
	,	UPDATED_SITE_SUCCESS
			,LOAD_MILESTONETEMPLATES_SUCCESS
		,LOAD_MILESTONETEMPLATE_SUCCESS
		,LOAD_MILESTONETEMPLATES_UPDATE_SUCCESS
		,DELETED_MILESTONETEMPLATE
		,MILESTONETEMPLATE_UPDATE_REQUIRED
		,DELETED_MILESTONETEMPLATE_INCOMING
		,UPDATED_MILESTONETEMPLATE_INCOMING
		,UPDATED_MILESTONETEMPLATE_SUCCESS	
		,LOAD_MILESTONETEMPLATEENTRY_SUCCESS
		,DELETED_MILESTONETEMPLATEENTRY
		,MILESTONETEMPLATEENTRY_UPDATE_REQUIRED
		,DELETED_MILESTONETEMPLATEENTRY_INCOMING
		,UPDATED_MILESTONETEMPLATEENTRY_INCOMING
		,UPDATED_MILESTONETEMPLATEENTRY_SUCCESS			
		,DELETED_PHASENOTE		
		,DELETED_PHASENOTE_INCOMING
		,UPDATED_PHASENOTE_INCOMING
		,UPDATED_PHASENOTE_SUCCESS
	};

export default appTypes;

